<template>
  <div class="about section">
    <h1 class="article-title">ABOUT US</h1>
    <div
      class="article"
      v-html="data.results && data.results[0] && data.results[0].content"
    ></div>
    <div
      v-if="data.results && data.results[0] && data.results[0].document_url"
      style="margin-bottom: 80px"
    >
      <iframe
        :src="data.results && data.results[0] && data.results[0].document_url"
        frameborder="0"
        width="100%"
        height="1190"
        style="margin: 30px auto; display: block"
      ></iframe>
    </div>
    <!-- <div>
            <iframe
                src="/v1.pdf"
                frameborder="0"
                width="100%"
                height="1190"
                style="margin: 0 auto;display: block;"
            ></iframe>
        </div>-->
    <!-- <template>
            <button @click="handlePage">下一</button>
            <pdf ref="myPdfComponent" src="/v1.pdf" :page="page"></pdf>
        </template>-->
    <!-- <div class="article">
      <h3>OVERVIEW</h3>
      <p>
        As a Category II center of UNESCO, the International Center for
        Engineering Education under the Auspices of UNESCO (ICEE) was unveiled
        in Beijing on June 6, 2016. ICEE was proposed jointly by Chinese Academy
        of Engineering (CAE), a national consulting organization in engineering
        science and technology in China, and Tsinghua University, a top
        university well known in engineering science education.
      </p>
      <div class="img">
        <img
          src="../../assets/images/about/1.png"
          alt
          srcset
          style="margin: 0 25px"
        />
        <img
          src="../../assets/images/about/2.png"
          alt
          srcset
          style="margin: 0 25px"
        />
      </div>
      <h3>VISION</h3>
      <p>
        ICEE is committed to building itself into an equal, inclusive,
        developmental and win-win engineering education community for the
        promotion of quality and equity in engineering education amongst
        countries in the world.
      </p>
      <h3>MISSION</h3>
      <p>
        ICEE aims to be a think-tank for policy research, an incubator for
        high-caliber personnel, and an exchange and cooperation platform in
        global engineering education. ICEE focuses on talent cultivation of
        engineering for developing countries on the path of innovation-driven
        and industry-university collaboration, so as to support these countries
        in pursuing sustainable social and economic development which will
        benefit the individual persons, the local communities, the countries and
        the whole humankind.
      </p>
      <div class="img">
        <img src="../../assets/images/about/3.png" alt srcset />
      </div>
      <h3>ACTIVITIES</h3>
      <p>
        ICEE aims to be a think-tank for policy research, an incubator for
        high-caliber personnel, and an exchange and cooperation platform in
        global engineering education. ICEE focuses on talent cultivation of
        engineering for developing countries on the path of innovation-driven
        and industry-university collaboration, so as to support these countries
        in pursuing sustainable social and economic development which will
        benefit the individual persons, the local communities, the countries and
        the whole humankind.
      </p>
      <div class="img">
        <img src="../../assets/images/about/3-1.png" alt srcset />
      </div>
      <p>
        Incubator for high-caliber personnel. Capitalize on and expand the
        industry-university collaboration network of the Center, innovate
        educational mode in industry-university collaboration, and cultivate
        high-caliber engineering talents for developing countries, using both
        traditional and emerging approaches like MOOC as well as other ICT
        methods.
      </p>
      <div class="img">
        <img src="../../assets/images/about/4.png" alt srcset />
        <img src="../../assets/images/about/5.png" alt srcset />
      </div>
      <p>
        International exchange and cooperation. Open to all member states of
        UNESCO, emphasize UNESCO Global Priority Africa and Global Priority
        Gender Equality, and seek to expand its global exchange and cooperation
        network in engineering education, promote cross-border, cross-region,
        and cross-culture sharing of knowledge, experiences, and resources in
        engineering education.
      </p>
      <div class="img">
        <img src="../../assets/images/about/6.png" alt srcset />
      </div>
    </div> -->
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { useFetchItem } from "../../hooks/fetch-item";
import { api } from "../../utils/apis";
// import pdf from 'vue-pdf'
export default defineComponent({
  name: "About",
  components: {},
  setup() {
    // vue-pdf@4.2.0 没有错误信息
    // const currentPage = ref(0)
    // const pageCount = ref(0)
    // const page = ref(0)
    // const handlePage = () => {
    //     page.value = page.value + 1
    // }
    const { data } = useFetchItem({
      api: api.about_us,
    });

    return {
      data,
    };
  },
});
</script>
<style lang="scss" scoped>
.about {
  overflow: hidden;
  .article-title {
    height: 30px;
    font-size: 22px;
    font-weight: 600;
    color: #231916;
    line-height: 30px;
    text-align: center;
    margin: 40px;
  }
  .article {
    font-weight: 600;
    font-size: 14px;
    font-weight: 600;
    color: #7d7e80;
    line-height: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    h3 {
      margin-bottom: 10px;
    }
    p {
      margin-bottom: 2em;
    }
    .img {
      margin-bottom: 30px;
      text-align: center;
    }
  }
}
</style>
